import {createContext} from "react";
import {IAppDataSearch, IValidationErrors} from "./appData.interface";

export const appDataGeneratorContext = createContext({
    appDataSearch: {} as IAppDataSearch,
    setAppDataSearch: (appDataSearch: IAppDataSearch) => {    },
    runReport: (reportObj) => {    },
    isLoadingReport: false,
    validationErrors : {} as IValidationErrors,
    setValidationErrors: (validationErrors: (prevError) => any) => {    },
    reportData: null,
    reportColumns: null,
})
